export default __webpack_public_path__ + "static/media/xmai-logo-ellipse-transparent-260x260.8343174a.svg";